import type { Board } from "./board";
import type { Direction } from "./direction";
import { directionDelta } from "./direction";
import { MovementEffect } from "./effects/movementEffect";
import type { PointsToDirection } from "./interfaces";
import { Projectile } from "./projectile";
import type { XY } from "./xy";

export abstract class SimpleProjectile extends Projectile implements PointsToDirection {
	direction: Direction;

	constructor(xy: XY, direction: Direction) {
		super(xy);
		this.direction = direction;
	}

	processTurn(board: Board): void {
		super.processTurn(board);
		if (!this.active) return;
		if (board.currentProcessingPass !== 0) return;

		const oldXY = this.xy;
		const destination = this.xy.add(directionDelta(this.direction));
		if (this.moveTo(destination)) {
			board.addEffect(new MovementEffect(this, oldXY, destination));
		}
	}

	getDirection(): Direction | null {
		return this.direction;
	}

	setDirection(dir: Direction): void {
		this.direction = dir;
	}

	serialize(): Record<string, unknown> {
		return { ...super.serialize(), direction: this.direction };
	}
}
